import Facebook from 'assets/icons/facebook.svg';
import Linkedin from 'assets/icons/linkedin.svg';
import Twitter from 'assets/icons/twitter.svg';
import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { Text } from 'ui';

import TwoColumnsForm from '../../../components/TwoColumnsForm';
import ContactUsForm from '../ContactUsForm';

import s from './ContactUsContent.module.scss';

const cx = cn.bind(s);

const ContactUsContent = ({ className, formTitle, formText }) => {
  const leftColumnContent = (
    <>
      <h2 className={cx('tp-mobile-cta-block md:tp-tablet-header-3', 'infoTitle')}>Head office</h2>
      <div className={cx('infoGroups', 'tp-bold')}>
        <div className={cx('infoGroup')}>Beverly Hills, CA</div>
        <div className={cx('infoGroup', 'infoGroupAddress')}>
          <p className={cx('infoGroupAddressField')}>1901 Avenue of the Stars</p>
          <p className={cx('infoGroupAddressField')}>Los Angeles CA 90067</p>
        </div>
        <div className={cx('infoGroup')}>
          Phone: +1 (855) 342-8558
          <br />
          Email: {process.env.NEXT_PUBLIC_SUPPORT_EMAIL}
        </div>
      </div>
      <div className={cx('infoSharing')}>
        <div className={cx('infoSharingIcon')}>
          <Twitter />
        </div>
        <div className={cx('infoSharingIcon')}>
          <Linkedin />
        </div>
        <div className={cx('infoSharingIcon')}>
          <Facebook />
        </div>
      </div>
    </>
  );
  const rightColumnContent = (
    <>
      <h2 className={cx('tp-mobile-cta-block md:tp-tablet-header-3', 'formTitle')}>{formTitle}</h2>
      <Text className={cx('formInfo')}>{formText}</Text>
      <ContactUsForm />
    </>
  );
  return (
    <TwoColumnsForm
      className={className}
      leftColumn={leftColumnContent}
      rightColumn={rightColumnContent}
    />
  );
};

ContactUsContent.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ContactUsContent;
